<script lang="ts" setup>

</script>

<template>
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.608398" width="16" height="16" rx="8" fill="#337FFF"/>
    <path d="M9.95773 9.12927L10.1857 7.68084H8.78141V6.73935C8.78141 6.3433 8.97747 5.9563 9.60438 5.9563H10.2518V4.72287C9.87478 4.66274 9.4938 4.63022 9.11197 4.62555C7.95617 4.62555 7.20159 5.32034 7.20159 6.57641V7.68084H5.92041V9.12927H7.20159V12.6327H8.78141V9.12927H9.95773Z" fill="white"/>
  </svg>
</template>